import React from "react";
import { Card, CardBody, TabPane } from "reactstrap";
import TabContent from "../../../../../../../@dhn/components/atoms/tab-content";
import CardHeaderTabs from "../../../../../../../@dhn/components/molecules/card-header-tabs";
import Medicaments from "./subTabsPrescriptions/Medicaments";
import LaboratoryExams from "./subTabsPrescriptions/LaboratoryExams";
import ImagingStudies from "./subTabsPrescriptions/ ImagingStudies";
import MedicalLicenses from "./subTabsPrescriptions/MedicalLicenses";
import Referrals from "./subTabsPrescriptions/Referrals";

export default function Prescriptions({
  activeTab,
  onChange,
  loadMedicines,
  tabPrescription,
  handleAddMedicament,
  appointmentId,
  loadingSpecialties,
  loadMedicalStaffs,
  inputRef,
  isLoading,
  pageEdit,
  addToast,
  isPageModalHistory,
  patientId,
  appointmentDate,
  isLaboratoryLocked,
  handleSelectMedicine
}) {
  const {
    subTabMedicaments,
    subTabExamsLaboratory,
    subTabImageStudies,
    subTabMedicalLicenses,
    subTabReferences,
  } = tabPrescription;
  return (
    <TabPane tabId={4} className="p-0 m-0">
      <div className="animated fadeIn">
        <Card>
          <CardHeaderTabs
            onClick={(id) => onChange("activeTabPrescriptions", id)}
            active={activeTab}
            tabs={[
              {
                id: 1,
                name: "Medicamentos",
              },
              {
                id: 2,
                name: "Exámenes de Laboratorio",
              },
              {
                id: 3,
                name: "Estudios de Imágenes",
              },
              {
                id: 4,
                name: "Licencias Médicas",
              },
              {
                id: 5,
                name: "Referimientos",
              },
            ]}
          />
          <CardBody>
            <TabContent {...{ activeTab }}>
              <Medicaments
                {...{
                  loadMedicines,
                  onChange,
                  subTabMedicaments,
                  handleAddMedicament,
                  inputRef,
                  isLoading,
                  pageEdit,
                  addToast,
                  isPageModalHistory,
                  handleSelectMedicine
                }}
              />
              <LaboratoryExams
                {...{
                  subTabExamsLaboratory,
                  onChange,
                  appointmentId,
                  appointmentDate,
                  patientId,
                  isPageModalHistory,
                  isLaboratoryLocked,
                  otherResultRecords:
                    subTabImageStudies?.appointmentHistoryImages,
                }}
              />
              <ImagingStudies
                {...{
                  subTabImageStudies,
                  onChange,
                  appointmentId,
                  isPageModalHistory,
                  patientId,
                  otherResultRecords:
                    subTabExamsLaboratory?.appointmentHistoryLaboratory,
                }}
              />
              <MedicalLicenses
                {...{
                  subTabMedicalLicenses,
                  onChange,
                  appointmentId,
                  pageEdit,
                  isPageModalHistory,
                  patientId
                }}
              />
              <Referrals
                {...{
                  loadingSpecialties,
                  loadMedicalStaffs,
                  onChange,
                  appointmentId,
                  subTabReferences,
                  pageEdit,
                  isPageModalHistory,
                }}
              />
            </TabContent>
          </CardBody>
        </Card>
      </div>
    </TabPane>
  );
}
